<template>
  <section class="itinerario-poster" ref="sectionRef">

    <!-- VIDEO FONDO -->
   <img :src="require('@/assets/fondi.gif')" class="video-fondo" />

    <!-- OVERLAY PARA MEJOR VISIBILIDAD -->
    <div class="overlay"></div>

    <!-- RASGADO SUPERIOR -->
    <div class="rasgado rasgado-top"></div>

<h2 class="poster-title">Schedule</h2>
    <div
      v-for="(evento, index) in eventos"
      :key="evento.nombre"
      class="poster-item"
      :ref="el => itemRefs[index] = el"
    >
      <img :src="evento.icono" class="poster-icon" />
      <p class="poster-text">
        <span class="evento-nombre">{{ evento.nombre }}</span>
        <span class="evento-hora">{{ evento.hora }}</span>
        <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
      </p>
    </div>

    <!-- RASGADO INFERIOR -->
    <div class="rasgado rasgado-bottom"></div>

  </section>
</template>
<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [

      {
        nombre: 'Reception',
        hora: '7:00 PM',
        icono: require('@/assets/copa1.png')
      },
        {
        nombre: 'Dinner',
        hora: '7:30 PM',
        icono: require('@/assets/cena.png')
      },
      {
        nombre: 'Presentation ',
        hora: '9:00 PM',
        icono: require('@/assets/co.png')
      },
      
      {
        nombre: ' Dance',
        hora: '10:00 PM ',
        icono: require('@/assets/quince.png')
      },
     
      {
        nombre: ' Party',
        hora: '10:30 PM',
        icono: require('@/assets/disc.png')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef }
  }
}
</script>
<style scoped>
.itinerario-poster {
  position: relative; /* 🔥 CLAVE PARA QUE EL RASGADO FUNCIONE */
  overflow: hidden;
  padding: 60px 20px 80px;
  text-align: center;
}

.video-fondo{
  position:absolute;
  top:0;
  left:0;
  width:100vw;   /* 🔥 clave */
  height:170vh;  /* 🔥 clave */
  object-fit:cover;
  z-index:0;
  pointer-events:none;
}
/* VIDEO */
.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Filtros para aclarar */
  filter: brightness(1.9) contrast(0.9); 
  /* 1.2 sube el brillo un 20%, 0.9 suaviza las sombras */
  object-fit: cover;
  z-index: 0;
}

/* OVERLAY */
.overlay {
  position: absolute;
  inset: 0;
  background: rgba(140, 182, 209, 0.45);
  z-index: 1;
}

/* CONTENIDO ARRIBA */
.poster-title,
.poster-item {
  position: relative;
  z-index: 2;
}

/* TEXTO BLANCO */
.poster-title {
  font-family: 'titulos', cursive;
  font-size: 68px;
  letter-spacing: 2px;
  color: #ffffff;
  margin-bottom: 50px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #ffffff;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
  color: #ffffff;
}

.evento-nota {
  display: block;
  font-size: 14px;
  margin-top: 6px;
  color: #ffffff;
}

/* ICONO */
.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
  position: relative;
  z-index: 2;
}

/* ITEMS */
.poster-item {
  margin-bottom: 42px;
}

/* RASGADOS */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  z-index: 3;
  pointer-events: none;
}

.rasgado-top {
  top: 0;
  background: linear-gradient(
    90deg,
    rgba(235, 243, 250, 0.76) 0%,
    rgba(212, 232, 237, 0.872) 50%,
    rgba(255, 255, 255, 0.925) 100%
  );  clip-path: polygon(
    0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%
  );
}

.rasgado-bottom {
  bottom: 0;
  background: #8fbbdf !important;
  clip-path: polygon(
    0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%
  );
}
</style>